import { render, staticRenderFns } from "./NsHeaderTop.vue?vue&type=template&id=a00dc542&scoped=true"
import script from "./NsHeaderTop.vue?vue&type=script&lang=js"
export * from "./NsHeaderTop.vue?vue&type=script&lang=js"
import style0 from "./NsHeaderTop.vue?vue&type=style&index=0&id=a00dc542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00dc542",
  null
  
)

export default component.exports